import React, { useState } from "react";
import {
  makeStyles,
  Button,
  Modal,
  Backdrop,
  FormControl,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import Grid from "@mui/material/Grid";

import "./CSS/vrfklimasantral.css";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import CancelIcon from "@mui/icons-material/Cancel";
import { useEffect } from "react";
import axiosInstance from '../services/axiosConfig';

import { Input } from "@mui/material";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_vrfks_tags,
  set_external_trend_info,
  set_combine_trends,
} from "../Action/Action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    flex: 1,
    gap: "3px",

    marginTop: "13%",
    marginLeft: "1%",
  },

  topButtonContainer: {
    position: "absolute",
    top: "4%",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    justifyContent: "center",
  },

  pageroot: {
    width: "100%",
    height: "100vh",
    display: "flex",
    position: "relative",
  },

  lockButton: {
    marginLeft: theme.spacing(1),
  },
  floorTitle: {
    position: "absolute",
    top: "9%",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "2rem !important",
    fontWeight: 600,
    color: "black",
    padding: theme.spacing(1),
  },
  navigationButtonForward: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  navigationButtonBack: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  button: {
    backgroundColor: "lightgray",
    border: "2px solid rgb(67, 51, 22)",
    height: "5rem",
    width: "16rem",
    fontSize: "0.8rem",
    fontWeight: 700,

    whiteSpace: "nowrap",

    borderRadius: "20px",
    "&:focus": {
      outline: "none",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid rgb(237, 188, 69)",
    boxShadow: theme.shadows[5],
    maxWidth: 400,
    minWidth: 350,
    padding: theme.spacing(2, 5.5, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  statusRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "3rem",
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  sogutmaısıtma: {
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  statusLabel: {
    marginRight: theme.spacing(2),
    minWidth: "150px",
    fontWeight: 600,
  },
  formControl: {
    flexGrow: 1,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  select: {
    width: "100%",
  },
}));

const initalState = [
  {
    701: [
      { text: "Oda Sıcaklığı", tagId: "8701" },
      { text: "Oda Set Değeri", tagId: "8703" },
      { text: "Cihaz", tagId: "8711", tagId2: "8709" },
      { text: "Çalışma Modu", tagId: "8717", tagId2: "8723" },
      { text: "Çalışma Durumu", tagId: "8717" },
      { text: "Fan Modu", tagId: "8727", tagId2: "8724" },
      { text: "Soğutma Modu Set Değeri", tagId: "5107" },
      { text: "Isıtma Modu Set Değeri", tagId: "5108" },
      { text: "Filtre Durumu", tagId: "8712" },
      { text: "Filtre Reset", tagId: "8721" },
      { text: "Arıza Durumu", tagId: "8715" },
      { text: "Arıza Kodu", tagId: "8718" },
    ],
  },
  {
    702: [
      { text: "Oda Sıcaklığı", tagId: "8702" },
      { text: "Oda Set Değeri", tagId: "8706" },
      { text: "Cihaz", tagId: "8713", tagId2: "8710" },
      { text: "Çalışma Modu", tagId: "8719", tagId2: "8725" },
      { text: "Çalışma Durumu", tagId: "8719" },

      { text: "Fan Modu", tagId: "8728", tagId2: "8726" },
      { text: "Soğutma Modu Set Değeri", tagId: "5101" },
      { text: "Isıtma Modu Set Değeri", tagId: "5102" },
      { text: "Filtre Durumu", tagId: "8714" },
      { text: "Filtre Reset", tagId: "8722" },
      { text: "Arıza Durumu", tagId: "8716" },
      { text: "Arıza Kodu", tagId: "8720" },
    ],
  },
];

let revisedState = {};

initalState.forEach((room) => {
  const roomId = Object.keys(room)[0];
  const roomTags = room[roomId];

  roomTags.forEach((tag) => {
    const text = tag.text;
    const tagId = tag.tagId;

    if (!revisedState[text]) {
      revisedState[text] = [];
    }

    revisedState[text].push(tagId);
  });
});
const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  initalState.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
      // tagId2 varsa onu da ekleyelim
      if (item3.tagId2) {
        obj2__.push({ tagId: item3.tagId2 });
      }
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/vrfks") {
        try {
          const request = await axiosInstance.post(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            obj2__
          );
          const response = request.data;

          const updatedResponse = response.map((item) => {
            const matchedItem = obj2__.find(
              (objItem) => objItem.tagId === item.tagId
            );
            return {
              ...item,
              tagId2: matchedItem ? matchedItem.tagId : null,
            };
          });

          Store.dispatch(set_vrfks_tags(response));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 1000);
};

setTimeout(() => {
  inital_func();
}, 100);

const VRFKS = (props) => {
  const classes = useStyles();

  const [render_state, Set_render_state] = useState([]);

  useEffect(() => {
    Set_render_state(props.vrfks_tags);
  }, [props.vrfks_tags]);
  const [open, setOpen] = useState(Array(2).fill(false));

  const [state, Set_state] = useState(initalState);

  const history = useHistory();

  const [locked, setLocked] = useState({
    701: { odasetdegeri: false },
    702: { odasetdegeri: false },
  });

  //yetkilendirme
  const [vrf_okuma_control, Set_vrf_okuma_control] = useState(false);

  useEffect(() => {
    if (props.yetkilendirme && props.uid !== "") {
      let data = props.yetkilendirme;
      let newObj = data[props.uid];
      if (newObj !== undefined) {
        if (newObj["VRF"]["Y"] === "t") {
          Set_vrf_okuma_control(true);
        } else {
          Set_vrf_okuma_control(false);
        }
      }
    }
  }, [props.yetkilendirme]);

  const [active_room_number, Set_active_room_number] = useState(null);

  const toggleLock = (roomNumber, selectType) => {
    setLocked((prevLocked) => {
      const newLocked = {
        ...prevLocked,
        [roomNumber]: {
          ...prevLocked[roomNumber],
          [selectType]: !prevLocked[roomNumber]?.[selectType],
        },
      };
      console.log("kilitlendi:", newLocked);
      return newLocked;
    });
  };

  const handleOpen = (index) => {
    let newOpen = [...open];
    newOpen[index] = true;
    setOpen(newOpen);
  };

  const handleClose = (roomNumber) => {
    const index = roomNumber - 701;
    let newOpen = [...open];
    newOpen[index] = false;
    setOpen(newOpen);
    Set_active_room_number(null);
  };

  const [cihazselectValue, setcihazSelectValue] = useState({
    701: "ON",
    702: "ON",
  });

  const [lock, Setlock] = useState({
    701: "0",
    702: "0",
  });

  const [cihazled, Setcihazled] = useState({
    701: "green",
    702: "green",
  });

  const CihazSelectChange = (event) => {
    setcihazSelectValue(event.target.value);
  };
  const [calismamoduselectValue, setcalismamoduSelectValue] = useState({
    701: "ISITMA",
    702: "ISITMA",
  });

  const CalismaModuSelectChange = (event, roomNumber) => {
    var newObj = calismamoduselectValue;
    newObj[roomNumber] = event.target.value;

    setcalismamoduSelectValue(newObj);
  };
  const [fanmoduselectValue, setfanmoduSelectValue] = useState({
    701: "1 ",
    702: "1 ",
  });
  const [filtredurumselectValue, setfiltreselectSelectValue] = useState({
    701: "TEMİZ",
    702: "TEMİZ",
  });
  const [arızadurumselectValue, setarızadurumSelectValue] = useState("NORMAL");
  const [arızakoduselectValue, setarızakoduSelectValue] = useState("0");

  const FanModuSelectChange = (event) => {
    setfanmoduSelectValue(event.target.value);
  };
  const FiltreDurumSelectChange = (event) => {
    setfiltreselectSelectValue(event.target.value);
  };
  const ArızaDurumSelectChange = (event) => {
    setarızadurumSelectValue(event.target.value);
  };
  const ArızaKoduSelectChange = (event) => {
    const selectedArızaKodu = event.target.value;
    setarızakoduSelectValue(selectedArızaKodu);

    if (selectedArızaKodu === "0") {
      setarızadurumSelectValue("NORMAL");
    } else if (selectedArızaKodu === "1") {
      setarızadurumSelectValue("ALARM");
    }
  };

  const initialOdaSetDegerler = {
    701: "25",
    702: "25",
  };

  const initialSogutmamoduSet = {
    701: "19",
    702: "19",
  };
  const initialSogutmamoduUst = {
    701: "22",
    702: "22",
  };
  const initialSogutmamoduAlt = {
    701: "18",
    702: "18",
  };
  const initialIsıtmamoduSet = {
    701: "28",
    702: "28",
  };
  const initialIsıtmamoduUst = {
    701: "30",
    702: "30",
  };
  const initialIsıtmamoduAlt = {
    701: "26",
    702: "26",
  };

  const sendSetValueFunc = async (list_) => {
    try {
      console.log("sendSetValueFunc çağrıldı", list_);

      // API çağrısını yap
      const req = await axiosInstance.post(
        "https://app-rmmscmdapi.azurewebsites.net/api/cmd/SetValue",
        list_
      );

      // API yanıtını işle
      const response = req.data;
      console.log("API yanıtı:", response);

      {
        console.log("API çağrısı başarılı, verileri güncelleniyor.");

        // Tag değerlerini al
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
            // tagId2 varsa onu da ekleyelim
            if (item3.tagId2) {
              obj2__.push({ tagId: item3.tagId2 });
            }
          });
        });

        console.log("Tag ID'leri:", obj2__);

        // Tag değerlerini al ve güncelle
        const fetch_tag_values = async () => {
          if (window.location.pathname === "/vrfks") {
            try {
              const request = await axiosInstance.post(
                "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                obj2__
              );
              const response = request.data;

              // Gelen yanıtın içerisinde tagId2'leri bulup ekliyoruz
              const updatedResponse = response.map((item) => {
                const matchedItem = obj2__.find(
                  (objItem) => objItem.tagId === item.tagId
                );
                return {
                  ...item,
                  tagId2: matchedItem ? matchedItem.tagId : null,
                };
              });

              console.log("Tag değerleri alındı:", response);

              Store.dispatch(set_vrfks_tags(response));
            } catch (err) {
              console.log("Tag değerleri fetch hatası:", err);
            } finally {
              Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
            }
          }
        };

        await fetch_tag_values();
      }
    } catch (error) {
      console.log("sendSetValueFunc hatası:", error);
    }
  };

  // const fakeSendSetValueFunc = async (list_) => {
  //
  //   try {
  //     console.log("fakeSendSetValueFunc çağrıldı", list_);

  //     // Fake API yanıtını simüle et
  //     const fakeApiResponse = {
  //       status: 200,
  //       json: async () => ({
  //         success: true,
  //         message: "Fake API çağrısı başarılı!",
  //         data: list_,
  //       }),
  //     };

  //     // API yanıtını işleyelim
  //     const response = await fakeApiResponse.json();
  //     console.log("Fake API yanıtı:", response);
  //     console.log("HTTP durum kodu:", fakeApiResponse.status);

  //     if (fakeApiResponse.status === 200) {
  //       console.log("Fake API çağrısı başarılı, veriler güncelleniyor.");

  //       // Tag değerlerini al
  //       var obj__ = [];
  //       var obj2__ = [];

  //       initalState.forEach((item) => {
  //         Object.entries(item).forEach((a) => {
  //           obj__.push(a[1]);
  //         });
  //       });

  //       obj__.forEach((item2) => {
  //         item2.forEach((item3) => {
  //           obj2__.push({ tagId: item3.tagId });
  //           // tagId2 varsa onu da ekleyelim
  //           if (item3.tagId2) {
  //             obj2__.push({ tagId: item3.tagId2 });
  //           }
  //         });
  //       });

  //       console.log("Tag ID'leri:", obj2__);

  //       // Fake tag değerlerini al ve güncelle
  //       const fakeFetchTagValues = async () => {
  //         if (window.location.pathname === "/vrfks") {
  //           try {
  //             const fakeTagResponse = obj2__.map((tag) => ({
  //               tagId: tag.tagId,
  //               value: Math.random() * 100, // Rastgele bir değer döndür
  //             }));

  //             const updatedResponse = fakeTagResponse.map((item) => {
  //               const matchedItem = obj2__.find(
  //                 (objItem) => objItem.tagId === item.tagId
  //               );
  //               return {
  //                 ...item,
  //                 tagId2: matchedItem ? matchedItem.tagId : null,
  //               };
  //             });

  //             console.log("Fake tag değerleri alındı:", updatedResponse);

  //             Store.dispatch(set_vrfks_tags(updatedResponse));
  //           } catch (err) {
  //             console.log("Fake tag değerleri fetch hatası:", err);
  //           } finally {
  //             Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
  //           }
  //         }
  //       };

  //       await fakeFetchTagValues();
  //     } else {
  //       console.log("Fake API çağrısı başarısız:", fakeApiResponse.status);
  //     }
  //   } catch (error) {
  //     console.log("fakeSendSetValueFunc hatası:", error);
  //   }
  // };

  const handleOdaSetDegeriDone = (roomNumber) => {
    const updatedValue = String(odasetdegerler[roomNumber]);
    let tagId;

    state.forEach((item) => {
      if (item[String(roomNumber)]) {
        tagId = item[String(roomNumber)].find(
          (x) => x.text === "Oda Set Değeri"
        )?.tagId;
      }
    });

    if (tagId) {
      sendSetValueFunc({
        TagId: String(tagId),
        TagValue: updatedValue,
      });
    }
  };

  const [odasetdegerler, setOdasetdegerler] = useState(initialOdaSetDegerler);
  const [initialOdasetdegerler, setInitialOdasetdegerler] = useState(
    initialOdaSetDegerler
  );
  const [sogutmamoduSet, SetsogutmamoduSet] = useState(initialSogutmamoduSet);
  const [initialSogutmaModuSet, setInitialSogutmamoduSet] = useState(
    initialSogutmamoduSet
  );
  const [sogutmamoduUst, SetsogutmamoduUst] = useState(initialSogutmamoduUst);
  const [initialSogutmaModuUst, setInitialSogutmamoduUst] = useState(
    initialSogutmamoduUst
  );
  const [sogutmamoduAlt, SetsogutmamoduAlt] = useState(initialSogutmamoduAlt);
  const [initialSogutmaModuAlt, setInitialSogutmamoduAlt] = useState(
    initialSogutmamoduAlt
  );
  const [ısıtmamoduSet, SetısıtmamoduSet] = useState(initialIsıtmamoduSet);
  const [initialIsıtmaModuSet, setInitialIsıtmamoduSet] =
    useState(initialIsıtmamoduSet);
  const [ısıtmamoduUst, SetısıtmamoduUst] = useState(initialIsıtmamoduUst);
  const [initialIsıtmaModuUst, setInitialIsıtmamoduUst] =
    useState(initialIsıtmamoduUst);
  const [ısıtmamoduAlt, SetısıtmamoduAlt] = useState(initialIsıtmamoduAlt);
  const [initialIsıtmaModuAlt, setInitialIsıtmamoduAlt] =
    useState(initialIsıtmamoduAlt);

  const [active_rm2, Set_active_rm2] = useState(false); // render modal 2

  const [setDegerleri, SETSetDegerleri] = useState(false);

  useEffect(() => {
    if (props.vrfks_tags.length > 0) {
      console.log(props.vrfks_tags);

      const inital_func = () => {
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
            // tagId2 varsa onu da ekleyelim
            if (item3.tagId2) {
              obj2__.push({ tagId: item3.tagId2 });
            }
          });
        });

        const fetch_tag_values = async () => {
          if (window.location.pathname === "/vrfks") {
            try {
              const request = await axiosInstance.post(
                "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                obj2__
              );
              const response = request.data;

              // Gelen yanıtın içerisinde tagId2'leri bulup ekliyoruz
              const updatedResponse = response.map((item) => {
                const matchedItem = obj2__.find(
                  (objItem) => objItem.tagId === item.tagId
                );
                return {
                  ...item,
                  tagId2: matchedItem ? matchedItem.tagId : null,
                };
              });

              Store.dispatch(set_vrfks_tags(updatedResponse));
              Set_render_state(updatedResponse);
            } catch (err) {
              console.log(err);
            } finally {
              Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
            }
          }
        };
        fetch_tag_values();
      };

      inital_func();

      var title = [];
      var title2 = [];
      var title3 = [];
      var title4 = [];

      var tag_values_set = [];
      var tag_values_set2 = [];
      var tag_values_set3 = [];
      var tag_values_calisma = [];
      var tag_values_cihaz = [];
      var tag_values_fan = [];
      var tag_values_led = [];
      var tag_values_filtre = [];
      var tag_lock = [];

      var newdata = [];
      var newdata2 = [];
      var newdata3 = [];

      state.map((item, index) => {
        var obj_ = [];
        Object.entries(item).forEach((a) => {
          title.push(a[0]);
          title2.push(a[0]);
          title3.push(a[0]);
          title4.push(a[0]);

          obj_.push(a[1]);
        });
        obj_[0].forEach((item_) => {
          console.log(item_);
          props.vrfks_tags.forEach((item2) => {
            if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Oda Set Değeri"
            ) {
              console.log(item2.tagValue);
              tag_values_set.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Soğutma Modu Set Değeri"
            ) {
              tag_values_set2.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Isıtma Modu Set Değeri"
            ) {
              tag_values_set3.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === " Cihaz"
            ) {
              tag_lock.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Çalışma Modu"
            ) {
              console.log(item2.tagValue);
              tag_values_calisma.push(
                item2.tagValue.trim() === "2"
                  ? "ISITMA"
                  : item2.tagValue.trim() === "1"
                  ? "SOĞUTMA"
                  : item2.tagValue.trim() === "5"
                  ? "NEM ALMA"
                  : item2.tagValue.trim() === "3"
                  ? "FAN"
                  : "AUTO"
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Cihaz"
            ) {
              tag_values_cihaz.push(
                item2.tagValue.trim() === "0" ? "OFF" : "ON"
              );
              tag_values_led.push(
                item2.tagValue.trim() === "0" ? "gray" : "green"
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Fan Modu"
            ) {
              const valueMapping = {
                1: "DÜŞÜK",
                2: "HIZLI",
                3: "ORTA 2",
                4: "ORTA",
                5: "AUTO",
              };

              tag_values_fan.push(
                valueMapping[item2.tagValue.trim()] || item2.tagValue.trim()
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Filtre Durumu"
            ) {
              console.log(item2.tagValue);
              //
              tag_values_filtre.push(
                item2.tagValue.trim() === "1" ? "TEMİZ" : "KİRLİ"
              );
            }
          });
        });
      });

      console.log(tag_values_set);

      var obj2_2 = {
        701: "ISITMA",
        702: "ISITMA",
      };

      var obj2_7 = {
        701: "TEMİZ",
        702: "TEMİZ",
      };

      var obj2_3 = {
        701: "ON",
        702: "ON",
      };

      var obj2_4 = {
        701: "1 ",
        702: "1 ",
      };

      var obj2_5 = {
        701: "green",
        702: "green",
      };

      var obj2_lock = {
        701: "0",
        702: "0",
      };

      console.log(obj2_2);
      //

      console.log(title, title2, title3, tag_values_calisma);
      for (let i = 0; i < title.length; i++) {
        newdata[title[i]] = tag_values_set[i].trim();
      }
      for (let i = 0; i < title2.length; i++) {
        newdata2[title2[i]] = tag_values_set2[i].trim();
      }
      for (let i = 0; i < title3.length; i++) {
        newdata3[title3[i]] = tag_values_set3[i].trim();
      }

      for (let k = 0; k < 2; k++) {
        obj2_2[String(k + 701)] = tag_values_calisma[k];
      }
      for (let k = 0; k < 2; k++) {
        obj2_3[String(k + 701)] = tag_values_cihaz[k];
      }
      for (let k = 0; k < 2; k++) {
        obj2_4[String(k + 701)] = tag_values_fan[k];
      }
      for (let k = 0; k < 2; k++) {
        obj2_5[String(k + 701)] = tag_values_led[k];
      }
      for (let k = 0; k < 2; k++) {
        obj2_7[String(k + 701)] = tag_values_filtre[k];
      }

      for (let k = 0; k < 2; k++) {
        obj2_lock[String(k + 701)] = tag_lock[k];
      }

      setOdasetdegerler(newdata);
      SetsogutmamoduSet(newdata2);
      SetısıtmamoduSet(newdata3);

      console.log(obj2_2);

      Setcihazled(obj2_5);
      Setlock(obj2_lock);

      setcihazSelectValue(obj2_3);
      setcalismamoduSelectValue(obj2_2);
      setfanmoduSelectValue(obj2_4);
      setfiltreselectSelectValue(obj2_7);
    }
  }, []);

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  const handleInputChange = (roomNumber, type) => (event) => {
    const newValue =
      event.target.value === ""
        ? ""
        : Math.max(18, Math.min(30, Number(event.target.value)));

    switch (type) {
      case "odasetdeger":
        setOdasetdegerler((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduSet":
        SetsogutmamoduSet((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduUst":
        SetsogutmamoduUst((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduAlt":
        SetsogutmamoduAlt((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduSet":
        SetısıtmamoduSet((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduUst":
        SetısıtmamoduUst((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduAlt":
        SetısıtmamoduAlt((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    setInitialOdasetdegerler(odasetdegerler);
    setInitialSogutmamoduSet(sogutmamoduSet);
    setInitialSogutmamoduUst(sogutmamoduUst);
    setInitialSogutmamoduAlt(sogutmamoduAlt);
    setInitialIsıtmamoduSet(ısıtmamoduSet);
    setInitialIsıtmamoduUst(ısıtmamoduUst);
    setInitialIsıtmamoduAlt(ısıtmamoduAlt);
  }, []);

  useEffect(() => {
    console.log("VRFKS TAGS = ", props.vrfks_tags);
  }, [props.vrfks_tags]);

  const [isEditing1, setIsEditing1] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [isEditing3, setIsEditing3] = useState(false);
  const [isEditing4, setIsEditing4] = useState(false);
  const [isEditing5, setIsEditing5] = useState(false);
  const [isEditing6, setIsEditing6] = useState(false);

  const handleEditStart1 = () => {
    setIsEditing1(true);
  };
  const handleEditStart2 = () => {
    setIsEditing2(true);
  };
  const handleEditStart3 = () => {
    setIsEditing3(true);
  };
  const handleEditStart4 = () => {
    setIsEditing4(true);
  };
  const handleEditStart5 = () => {
    setIsEditing5(true);
  };
  const handleEditStart6 = () => {
    setIsEditing6(true);
  };

  const handleEditCancel1 = () => {
    setIsEditing1(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone1 = () => {
    setIsEditing1(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel2 = () => {
    setIsEditing2(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone2 = () => {
    setIsEditing2(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel3 = () => {
    setIsEditing3(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone3 = () => {
    setIsEditing3(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel4 = () => {
    setIsEditing4(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone4 = () => {
    setIsEditing4(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel5 = () => {
    setIsEditing5(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone5 = () => {
    setIsEditing5(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel6 = () => {
    setIsEditing6(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone6 = () => {
    setIsEditing6(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };

  const [active, Set_active] = useState(false);

  const [changed_values, Set_changed_values] = useState([]);
  const [changed_values2, Set_changed_values2] = useState([]);

  useEffect(() => {
    setInitialOdasetdegerler(odasetdegerler);
    setInitialSogutmamoduSet(sogutmamoduSet);
    setInitialSogutmamoduUst(sogutmamoduUst);
    setInitialSogutmamoduAlt(sogutmamoduAlt);
    setInitialIsıtmamoduSet(ısıtmamoduSet);
    setInitialIsıtmamoduUst(ısıtmamoduUst);
    setInitialIsıtmamoduAlt(ısıtmamoduAlt);
    setTimeout(() => {
      Set_changed_values([]);
      Set_changed_values2([]);
    }, 3000);
  }, []);

  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Isıtma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Isıtma"]);
    }
  }, [ısıtmamoduSet]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Soğutma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Soğutma"]);
    }
  }, [sogutmamoduSet]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("SET" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "SET"]);
    }
  }, [odasetdegerler]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Çalışma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Çalışma"]);
    }
  }, [calismamoduselectValue]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Fan" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Fan"]);
    }
  }, [fanmoduselectValue]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Cihaz" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Cihaz"]);
    }
  }, [cihazselectValue]);

  const genel_value_changes = (type, value) => {
    let newdata = changed_values2;
    var toplam_ = 0;
    for (let i of newdata) {
      if (type === i.type) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values2((Prevvalues) => [
        ...Prevvalues,
        { type: type, value: value },
      ]);
    }
  };

  const renderModalContent = (roomNumber) => {
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            handleClose(roomNumber);
            SETSetDegerleri(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{
            color: "rgb(28,28,28)",
            textAlign: "center",
          }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {`ODA ${roomNumber}`}
        </Typography>
        <div className="vrf-popup-select">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            if (title.length > 0 && obj_.length > 0) {
              return (
                <div style={{ width: "100%", marginRight: "16px" }}>
                  {obj_[0].map((x, index) => {
                    switch (x.text) {
                      case "Oda Sıcaklığı":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;

                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  let newX = clientX;
                                  let newY = clientY;

                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                labelId={`oda${roomNumber}-oda-sicakligi-label`}
                                id={`oda${roomNumber}-oda-sicakligi-select`}
                                displayEmpty
                                IconComponent={() => null}
                                disabled={!vrf_okuma_control}
                              >
                                <MenuItem>
                                  <span
                                    style={{
                                      display: "flex",
                                      width: "83%",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <em
                                      style={{ flex: 1, textAlign: "center" }}
                                    >
                                      {değerler_eleman}
                                    </em>
                                    <span
                                      style={{
                                        position: "relative",
                                        right: "7%",
                                        color: "rgba(0, 0, 0, 0.54)",
                                        fontSize: "1rem",
                                        fontWeight: 400,
                                      }}
                                    >
                                      °C
                                    </span>
                                  </span>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        );

                      case "Oda Set Değeri":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div
                            className={classes.statusRow}
                            id="vrf_pop_up_row"
                          >
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "120px" }}
                            >
                              <Input
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                className="oda-set-degeri-padding"
                                id={`oda${roomNumber}-oda-set-degeri-input`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={
                                  locked[roomNumber]?.odasetdegeri ||
                                  !vrf_okuma_control
                                }
                                value={odasetdegerler[roomNumber]}
                                onChange={(e) => {
                                  Set_active(true);
                                  SETSetDegerleri(true);

                                  handleInputChange(
                                    roomNumber,
                                    "odasetdeger"
                                  )(e);
                                }}
                                endAdornment={
                                  <InputAdornment
                                    className="vrf-derece"
                                    position="end"
                                  >
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Cihaz":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = String(Math.round(Number(değerler[0])));

                        var cihazDurumuText =
                          değerler_eleman === "0" ? "OFF" : "ON"; // Varsayılan ON olur

                        // tagId2 ve işlenmiş değerleri yazdır
                        console.log(
                          `TagId: ${x.tagId}, Değer: ${değerler_eleman}, Mod: ${cihazDurumuText} CİHAZZZZZZ`
                        );

                        var cihazRengi =
                          değerler_eleman === "0" ? "gray" : "green";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              CİHAZ
                            </Typography>
                            <div
                              className="deviceStatusIndicator"
                              style={{
                                backgroundColor:
                                  cihazRengi || cihazled[String(roomNumber)],
                              }}
                            ></div>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              <div
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.device) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                  }
                                }}
                                id="cihaz_modu_div"
                                className="cihaz_modu_div"
                                style={{
                                  color:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                              >
                                {cihazDurumuText ||
                                  cihazselectValue[String(roomNumber)]}
                              </div>
                              {locked[roomNumber]?.device || (
                                <ul className="cihaz_modu_menu">
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = cihazselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcihazSelectValue((prevValues) => ({
                                        ...prevValues,
                                        [roomNumber]: textCurrent,
                                      }));

                                      Setcihazled((prevCihazled) => ({
                                        ...prevCihazled,
                                        [String(roomNumber)]: "green",
                                      }));

                                      e.target.parentElement.classList.toggle(
                                        "cihaz_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                      document.querySelector(
                                        ".deviceStatusIndicator"
                                      ).style.backgroundColor = "green";
                                    }}
                                  >
                                    ON
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = cihazselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcihazSelectValue((prevValues) => ({
                                        ...prevValues,
                                        [roomNumber]: textCurrent,
                                      }));

                                      Setcihazled((prevCihazled) => ({
                                        ...prevCihazled,
                                        [String(roomNumber)]: "gray",
                                      }));
                                      e.target.parentElement.classList.toggle(
                                        "cihaz_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                      document.querySelector(
                                        ".deviceStatusIndicator"
                                      ).style.backgroundColor = "gray";
                                    }}
                                  >
                                    OFF
                                  </li>
                                </ul>
                              )}
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][2].device;
                                  }
                                });
                                let value = String(
                                  lock[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // Çalışma Modu
                      case "Çalışma Modu":
                        // tagId2'lerin listesini tanımla
                        var tagId2ler = [
                          "6808",
                          "6805",
                          "6802",
                          "6799",
                          "6796",
                          "6793",
                        ];

                        // Eğer x.tagId2 tagId2ler listesinde varsa, render_state'ten filtrele
                        if (tagId2ler.includes(String(x.tagId2))) {
                          var değerler = render_state
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          var değerler_eleman = String(Math.round(Number(değerler[0]))); // Trimleme burada yapılıyor

                          // tagValue değerini işleme alıyoruz
                          var calismaModuText =
                            değerler_eleman === "2"
                              ? "ISITMA"
                              : değerler_eleman === "1"
                              ? "SOĞUTMA"
                              : değerler_eleman === "5"
                              ? "NEM ALMA"
                              : değerler_eleman === "3"
                              ? "FAN"
                              : "AUTO"; // Varsayılan AUTO olur

                          // tagId2 ve işlenmiş değerleri yazdır
                          console.log(
                            `TagId2: ${x.tagId2}, Değer: ${değerler_eleman}, Mod: ${calismaModuText}`
                          );
                        } else {
                          console.log(
                            `TagId2: ${x.tagId2}, eşleşen tagId bulunamadı`
                          );
                        }

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.mode) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                  }
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId2)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId2;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  let newX = clientX;
                                  let newY = clientY;

                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                id="calisma_modu_div"
                                className="calisma_modu_div"
                              >
                                {calismaModuText ||
                                  calismamoduselectValue[String(roomNumber)]}
                              </div>
                              {locked[roomNumber]?.mode || (
                                <ul className="calisma_modu_menu">
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    ISITMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    SOĞUTMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    NEM ALMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    AUTO
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    FAN
                                  </li>
                                </ul>
                              )}
                            </FormControl>
                            <IconButton
                              onClick={() => toggleLock(roomNumber, "mode")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.mode ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // Çalışma Durumu
                      case "Çalışma Durumu":
                        // Filtrelenmiş tagId ve tagValue'leri al
                        var çalışmaModuDeğerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);

                        // İlk elemanı al
                        var çalışmaModuEleman = çalışmaModuDeğerler[0];

                        // TagId ve değerleri konsola yazdır
                        console.log(
                          `TagId: ${x.tagId}, Değer: ${çalışmaModuEleman}`
                        );

                        // Rengi belirle
                        var çalışmaDurumuRengi =
                          çalışmaModuEleman === "1 "
                            ? "cornflowerblue"
                            : çalışmaModuEleman === "2 "
                            ? "red"
                            : "gray";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA DURUMU
                            </Typography>
                            <div
                              style={{
                                backgroundColor: çalışmaDurumuRengi,
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                position: "absolute",
                                left: "65%",
                              }}
                            ></div>
                          </div>
                        );

                      case "Fan Modu":
                        var tagId2ler = [
                          "6809",
                          "6806",
                          "6803",
                          "6800",
                          "6797",
                          "6794",
                        ];

                        // Eğer x.tagId2 tagId2ler listesinde varsa, render_state'ten filtrele
                        if (tagId2ler.includes(String(x.tagId2))) {
                          var değerler = render_state
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          var değerler_eleman = değerler[0]; // Trimleme burada yapılıyor

                          var fanModuText =
                            değerler_eleman === "1 "
                              ? "DÜŞÜK"
                              : değerler_eleman === "2 "
                              ? "HIZLI"
                              : değerler_eleman === "3 "
                              ? "ORTA 2"
                              : değerler_eleman === "4 "
                              ? "ORTA"
                              : "AUTO"; // Varsayılan AUTO olur

                          console.log(
                            `TagId2: ${x.tagId2}, Değer: ${değerler_eleman}, Mod: ${fanModuText} FANNNN`
                          );
                        } else {
                          console.log(
                            `TagId2: ${x.tagId2}, eşleşen tagId bulunamadı`
                          );
                        }
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              FAN MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{
                                  borderRadius: "4px",
                                  color: !vrf_okuma_control ? "gray" : "",
                                  border: !vrf_okuma_control
                                    ? "2px solid #edbc45"
                                    : "2px solid #edbc45",
                                  pointerEvents: !vrf_okuma_control
                                    ? "none"
                                    : "all",
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                id="fan_modu_div"
                                className="fan_modu_div"
                              >
                                {fanModuText ||
                                  fanmoduselectValue[String(roomNumber)]}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>

                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));
                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO{" "}
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                opacity: "0",
                                position: "relative",
                                zIndex: "-1000000",
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // case "Filtre Durumu":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];

                      //   değerler_eleman =
                      //     değerler_eleman === "1 " ? "TEMİZ" : "KİRLİ";

                      //   değerler_eleman =
                      //     değerler_eleman === "1 " ? "TEMİZ" : "KİRLİ";

                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {x.text.toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Select
                      //           disabled={!vrf_okuma_control}
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             // Calculate the new positions
                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             // Adjust if the popup would overflow the right edge of the viewport
                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             // Adjust if the popup would overflow the bottom edge of the viewport
                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             // Adjust if the popup would overflow the left edge of the viewport
                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             // Adjust if the popup would overflow the top edge of the viewport
                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             // Set the position of the popup
                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-filtre-durumu-label`}
                      //           id={`oda${roomNumber}-filtre-durumu-select`}
                      //           className="filtre-durum-class"
                      //           displayEmpty
                      //           value={
                      //             filtredurumselectValue[active_room_number]
                      //           }
                      //           onChange={FiltreDurumSelectChange}
                      //           IconComponent={() => null}
                      //         >
                      //           <MenuItem
                      //             value={
                      //               filtredurumselectValue[active_room_number]
                      //             }
                      //           >
                      //             <em>
                      //               {filtredurumselectValue[active_room_number]}
                      //             </em>
                      //           </MenuItem>
                      //         </Select>
                      //       </FormControl>
                      //     </div>
                      //   );
                      // case "Filtre Reset":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {x.text.toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Button
                      //           disabled={!vrf_okuma_control}
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             // Calculate the new positions
                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             // Adjust if the popup would overflow the right edge of the viewport
                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             // Adjust if the popup would overflow the bottom edge of the viewport
                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             // Adjust if the popup would overflow the left edge of the viewport
                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             // Adjust if the popup would overflow the top edge of the viewport
                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             // Set the position of the popup
                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-filtre-reset-label`}
                      //           id={`oda${roomNumber}-filtre-reset-buton`}
                      //           style={{
                      //             fontWeight: 600,

                      //             width: "155px",
                      //             padding: "1px 14px !important",
                      //             border: "2px solid #edbc45",
                      //             borderRadius: "4px",
                      //             color: "black",
                      //           }}
                      //           onClick={() => {
                      //             let tagId_;
                      //             state.forEach((a) => {
                      //               if (
                      //                 a[String(active_room_number)] !==
                      //                 undefined
                      //               ) {
                      //                 tagId_ =
                      //                   a[String(active_room_number)][8].tagId;
                      //               }
                      //             });
                      //             if (render_state.length > 0) {
                      //               render_state.forEach((x) => {
                      //                 if (x.tagId === String(tagId_)) {
                      //                   setfiltreselectSelectValue(
                      //                     (prevValues) => ({
                      //                       ...prevValues,
                      //                       [roomNumber]: "TEMİZ",
                      //                     })
                      //                   );
                      //                   sendSetValueFunc({
                      //                     TagId: String(tagId_),
                      //                     TagValue: x.tagValue.trim(),
                      //                   });
                      //                 }
                      //               });
                      //             }
                      //           }}
                      //         >
                      //           RESET
                      //         </Button>
                      //       </FormControl>
                      //     </div>
                      //   );

                      case "Arıza Durumu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        const arizaDurumuText =
                          değerler_eleman === "1 " ? "ARIZA" : "NORMAL";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                disabled
                                value={arizaDurumuText}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                id={`oda${roomNumber}-ariza-durumu-select`}
                                className="ariza-durum-class"
                                style={{
                                  color: "rgb(47, 47, 47)",
                                  fontWeight: 600,
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                <MenuItem value={arizaDurumuText}>
                                  <em className="ariza-durum-text">
                                    {arizaDurumuText}
                                  </em>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        );

                      case "Arıza Kodu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        console.log(değerler_eleman);
                        const arizaKoduText =
                          {
                            1: "NORMAL",
                            2: "OTHER ERRORS",
                            3: "REFRIGERATION SYSTEM FAULT",
                            4: "WATER SYSTEM ERROR",
                            5: "AIR SYSTEM ERROR",
                            6: "ELECTRONIC SYSTEM ERROR",
                            7: "SENSOR FAULT",
                            8: "COMMUNICATION ERROR",
                            9: "SYSTEM ERROR",
                          }[değerler_eleman ? değerler_eleman.trim() : ""] ||
                          "BILINMEYEN";

                        return (
                          <div>
                            <div className={classes.statusRow}>
                              <Typography
                                variant="subtitle1"
                                className={classes.statusLabel}
                                style={{ flex: 1, textAlign: "left" }} // Yazıyı sola yaslar
                              >
                                ARIZA KODU
                              </Typography>
                              <FormControl
                                variant="outlined"
                                className={classes.formControl}
                              >
                                <Select
                                  disabled
                                  value={arizaKoduText}
                                  onContextMenu={(e) => {
                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    var tagName = props.tag_list
                                      .filter((b) => b.tagId === x.tagId)
                                      .map((c) => c.tagName)[0];
                                    document.querySelector(
                                      ".show_tagName"
                                    ).innerHTML = tagName;
                                    document
                                      .querySelector(".show_external_trend")
                                      .classList.toggle(
                                        "show_external_trend_active"
                                      );
                                    document.querySelector(
                                      ".show_tagId"
                                    ).innerHTML = x.tagId;
                                    var popup = document.querySelector(
                                      ".show_external_trend"
                                    );
                                    const popupRect =
                                      popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                      newX + popupRect.width >
                                      viewportWidth
                                    ) {
                                      newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                      newY + popupRect.height >
                                      viewportHeight
                                    ) {
                                      newY = viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                      newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                      newY = 0;
                                    }

                                    // Set the position of the popup
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;
                                  }}
                                  id={`oda${roomNumber}-ariza-kodu-select`}
                                  className="ariza-durum-class"
                                  style={{
                                    color: "rgb(47, 47, 47)",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    width: "100%",
                                  }}
                                >
                                  <MenuItem value={arizaKoduText}>
                                    <em className="ariza-durum-text">
                                      {arizaKoduText}
                                    </em>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <button
                              onClick={() => {
                                let tagidsData = [];
                                initalState.forEach((a) => {
                                  Object.entries(a).forEach((x) => {
                                    if (String(active_room_number) === x[0]) {
                                      x[1].forEach((b) => {
                                        tagidsData.push({
                                          tagName: b.text,
                                          tagId: b.tagId,
                                        });
                                      });
                                    }
                                  });
                                });

                                Store.dispatch(set_combine_trends(tagidsData));
                                history.push("/raporlama");
                              }}
                              className="combine-trend_btn_vrf"
                              style={{
                                marginTop: "10px",
                                width: "100%",
                                margin: "0",
                                padding: "10px",
                              }}
                            >
                              KOMBİNE TREND
                            </button>
                            ;
                          </div>
                        );
                    }
                  })}
                </div>
              );
            }
          })}
        </div>
        {setDegerleri && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={() => {
                  try {
                    for (let i of changed_values) {
                      console.log("for içi i = ", i);
                      if (i === "Fan") {
                        //Fan Modu
                        let tagId_44;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_44 = a[String(active_room_number)][5].tagId2;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_44)) {
                              let fanValue;
                              switch (
                                fanmoduselectValue[String(active_room_number)]
                              ) {
                                case "DÜŞÜK":
                                  fanValue = "1 ";
                                  break;
                                case "HIZLI":
                                  fanValue = "2 ";
                                  break;
                                case "ORTA 2":
                                  fanValue = "3 ";
                                  break;
                                case "ORTA":
                                  fanValue = "4 ";
                                  break;
                                case "AUTO":
                                  fanValue = "5 ";
                                  break;
                                default:
                                  fanValue = "5 "; // Default olarak AUTO
                              }

                              sendSetValueFunc({
                                TagId: String(tagId_44),
                                TagValue: fanValue,
                              });
                            }
                          });
                        }
                      } else if (i === "Çalışma") {
                        //Çalışma Modu

                        let tagId_33;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_33 = a[String(active_room_number)][3].tagId2;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_33)) {
                              sendSetValueFunc({
                                TagId: String(tagId_33),
                                TagValue:
                                  calismamoduselectValue[
                                    String(active_room_number)
                                  ] === "ISITMA"
                                    ? "2"
                                    : calismamoduselectValue[
                                        String(active_room_number)
                                      ] === "SOĞUTMA"
                                    ? "1"
                                    : calismamoduselectValue[
                                        String(active_room_number)
                                      ] === "NEM ALMA"
                                    ? "5"
                                    : calismamoduselectValue[
                                        String(active_room_number)
                                      ] === "FAN"
                                    ? "3"
                                    : "AUTO",
                              });
                            }
                          });
                        }
                      } else if (i === "Cihaz") {
                        //Cihaz

                        let tagId_22;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_22 = a[String(active_room_number)][2].tagId2;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_22)) {
                              sendSetValueFunc({
                                TagId: String(tagId_22),
                                TagValue:
                                  cihazselectValue[
                                    String(active_room_number)
                                  ] === "OFF"
                                    ? "0 "
                                    : "1 ",
                              });
                            }
                          });
                        }
                      } else if (i === "SET") {
                        //Oda Set Değeri
                        let tagId_;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_ = a[String(active_room_number)][1].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_)) {
                              sendSetValueFunc({
                                TagId: String(tagId_),
                                TagValue: String(
                                  odasetdegerler[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                        handleOdaSetDegeriDone(roomNumber);
                      } else if (i === "Soğutma") {
                        //Soğutma Modu Set Değeri

                        let tagId_2;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_2 = a[String(active_room_number)][5].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_2)) {
                              sendSetValueFunc({
                                TagId: String(tagId_2),
                                TagValue: String(
                                  sogutmamoduSet[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                      } else if (i === "Isıtma") {
                        //Isıtma Set Değeri

                        let tagId_3;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_3 = a[String(active_room_number)][6].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_3)) {
                              sendSetValueFunc({
                                TagId: String(tagId_3),
                                TagValue: String(
                                  ısıtmamoduSet[active_room_number]
                                ),
                              });
                            }
                          });
                        }

                        SETSetDegerleri(false);
                      }
                    }
                    console.log("Changed VALUES === ", changed_values);
                    Set_changed_values([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };

  const [setDegerleri2, SETSetDegerleri2] = useState(false);

  const renderModalContent2 = (roomNumber) => {
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            Set_active_rm2(false);
            SETSetDegerleri2(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{ color: "rgb(28,28,28)" }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {"KLIMA SATRAL GENEL SİSTEM"}
        </Typography>
        <div className="vrf-popup-select">
          {Object.entries(revisedState).map((item, index) => {
            console.log(item);
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              console.log(a, roomNumber);
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            return (
              <div style={{ width: "100%", marginRight: "16px" }}>
                {item.map((x, index) => {
                  if (index < 1) {
                    switch (item[0]) {
                      case "Oda Set Değeri":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        const genel_oda_set_değeri = değerler_eleman;
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {item[0].toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "120px" }}
                            >
                              <Input
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                id={`oda-set-degeri-input-all`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={
                                  locked[roomNumber]?.odasetdegeri ||
                                  !vrf_okuma_control
                                }
                                onChange={(e) => {
                                  Set_active(true);
                                  SETSetDegerleri2(true);
                                  genel_value_changes("SET", 20);
                                  değerler_eleman = e.target.value;
                                }}
                                endAdornment={
                                  <InputAdornment
                                    className="vrf-derece"
                                    position="end"
                                  >
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Cihaz":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);

                        var değerler_eleman = değerler[0];

                        var cihazRengi =
                          değerler_eleman === "0 " ? "gray" : "green";

                        // CihazState değerine göre yuvarlağın rengini belirleme

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              CİHAZ
                            </Typography>
                            <div
                              className="deviceStatusIndicator"
                              style={{
                                backgroundColor: cihazled[String(roomNumber)],
                              }}
                            ></div>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "2px solid gray"
                                      : "2px solid rgb(23,23,23)",
                                  pointerEvents:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "cihaz_modu_menu_active"
                                  );
                                }}
                                className="cihaz_modu_div"
                              >
                                {değerler_eleman === "0 " ? "OFF" : "ON"}
                              </div>
                              <ul className="cihaz_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = cihazselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Cihaz", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    document.querySelector(
                                      ".deviceStatusIndicator"
                                    ).style.backgroundColor = "green";
                                  }}
                                >
                                  ON
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = cihazselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Cihaz", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    document.querySelector(
                                      ".deviceStatusIndicator"
                                    ).style.backgroundColor = "gray";
                                  }}
                                >
                                  OFF
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "device")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.device ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Çalışma Modu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "2px solid gray"
                                      : "2px solid rgb(23,23,23)",
                                  pointerEvents:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "calisma_modu_menu_active"
                                  );
                                }}
                                className="calisma_modu_div"
                              >
                                {değerler_eleman === "2 "
                                  ? "ISITMA"
                                  : değerler_eleman === "1 "
                                  ? "SOĞUTMA"
                                  : değerler_eleman === "5 "
                                  ? "NEM ALMA"
                                  : "FAN"}
                              </div>
                              <ul className="calisma_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ISITMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  SOĞUTMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  NEM ALMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  FAN
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "mode")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.mode ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Fan Modu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              FAN MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{
                                  right: "1%",
                                  color: !vrf_okuma_control ? "gray" : "",
                                  border: !vrf_okuma_control
                                    ? "2px solid gray"
                                    : "2px solid rgb(23,23,23)",
                                  pointerEvents: !vrf_okuma_control
                                    ? "none"
                                    : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                className="fan_modu_div"
                              >
                                {değerler_eleman === "1 "
                                  ? "DÜŞÜK"
                                  : değerler_eleman === "2 "
                                  ? "HIZLI"
                                  : değerler_eleman === "3 "
                                  ? "ORTA 2"
                                  : değerler_eleman === "4 "
                                  ? "ORTA"
                                  : değerler_eleman === "5 "
                                  ? "AUTO"
                                  : değerler_eleman}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    genel_value_changes("Fan", textCurrent);

                                    SETSetDegerleri2(true);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);
                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA{" "}
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO{" "}
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // case "Filtre Reset":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(item[1][0]))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {item[0].toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Button
                      //           disabled={!vrf_okuma_control}
                      //           labelId={`oda${roomNumber}-filtre-reset-label`}
                      //           id={`oda${roomNumber}-filtre-reset-buton`}
                      //           style={{
                      //             fontWeight: 600,
                      //             height: "2.5rem",
                      //             backgroundColor: "green",
                      //             width: "10rem",
                      //             fontSize: "1rem",
                      //             border: "2px solid black",
                      //             borderRadius: "4px",
                      //             color: "rgb(255, 255, 255)",
                      //           }}
                      //           onClick={() => {
                      //             değerler_eleman = değerler_eleman.slice(
                      //               0,
                      //               -1
                      //             );
                      //             revisedState["Filtre Reset"].forEach(
                      //               async (i) => {
                      //                 await sendSetValueFunc({
                      //                   TagId: i,
                      //                   TagValue: değerler_eleman,
                      //                 });
                      //               }
                      //             );
                      //           }}
                      //         >
                      //           RESET
                      //         </Button>
                      //       </FormControl>
                      //     </div>
                      //   );
                    }
                  }
                })}
              </div>
            );
          })}
        </div>
        {setDegerleri2 && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={() => {
                  console.log("aa");
                  try {
                    for (let i of changed_values2) {
                      console.log(i);
                      if (i.type === "Fan") {
                        // Fan Modu
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Fan Modu") {
                                let tagValue;

                                // Fan değerlerini belirle
                                switch (i.value) {
                                  case "DÜŞÜK":
                                    tagValue = "1 ";
                                    break;
                                  case "HIZLI":
                                    tagValue = "2 ";
                                    break;
                                  case "ORTA 2":
                                    tagValue = "3 ";
                                    break;
                                  case "ORTA":
                                    tagValue = "4 ";
                                    break;
                                  case "AUTO":
                                    tagValue = "5 ";
                                    break;
                                  default:
                                    tagValue = "5 "; // Default olarak AUTO
                                }

                                // Fake API çağrısını gönder
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: tagValue,
                                });
                              }
                            });
                          });

                          // Fan seçilen değerleri güncelle
                          const fanValue = i.value === "5" ? "AUTO" : i.value;
                          setfanmoduSelectValue({
                            701: fanValue,
                            702: fanValue,
                          });
                        });
                      } else if (i.type === "Çalışma") {
                        //Çalışma Modu
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Çalışma Modu") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "ISITMA"
                                      ? "2 "
                                      : i.value === "SOĞUTMA"
                                      ? "1 "
                                      : i.value === "NEM ALMA"
                                      ? "5 "
                                      : "3 "
                                  ),
                                });
                              }
                            });
                          });
                          setcalismamoduSelectValue({
                            701: i.value,
                            702: i.value,
                          });
                        });
                      } else if (i.type === "Cihaz") {
                        //Cihaz
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Cihaz") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "OFF" ? "0 " : "1 "
                                  ),
                                });
                              }
                            });
                          });
                          setcihazSelectValue({
                            701: i.value,
                            702: i.value,
                          });
                          Setcihazled({
                            701: i.value === "ON" ? "green" : "gray",
                            702: i.value === "ON" ? "green" : "gray",
                          });
                        });
                      } else if (i.type === "SET") {
                        //Oda Set Değeri
                        let value_all_set = document.querySelector(
                          "#oda-set-degeri-input-all"
                        ).value;

                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Oda Set Değeri") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId),
                                  TagValue: String(value_all_set),
                                });
                              }
                            });
                          });
                        });

                        setOdasetdegerler({
                          701: String(value_all_set),
                          702: String(value_all_set),
                        });
                      }
                    }
                    Set_changed_values2([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri2(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri2(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };
  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);
      //

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  const roomNames = {
    701: "Klima Santralleri 1",
    702: "Klima Santralleri 2",
  };

  const getTagIdForRoomCihaz = (roomNumber) => {
    const tagIdMap = {
      701: "8711",
      702: "8713",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomOperationMode = (roomNumber) => {
    const tagIdMap = {
      701: "8717",
      702: "8719",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomSetDeger = (roomNumber) => {
    const tagIdMap = {
      701: "8703",
      702: "8706",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomAnlik = (roomNumber) => {
    const tagIdMap = {
      701: "8701",
      702: "8702",
    };
    return tagIdMap[roomNumber] || null;
  };
  const getTagIdForRoomAriza = (roomNumber) => {
    const arizaTagIdMap = {
      701: "7234",
      702: "7237",
    };
    return arizaTagIdMap[roomNumber] || null;
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <div className={classes.pageroot + " "}>
        <div className={classes.topButtonContainer}>
          <button
            onClick={() => {
              Set_active_rm2(true);
            }}
            className="kat-bazı kat_bazı_vrf5"
          >
            KLİMA SANTRALLERİ
          </button>
        </div>

        <div className="move-main-vrf">
          <Link to="/VRF">
            <Button
              className={classes.navigationButtonBack + " movebuttonsvrf"}
              variant="contained"
            >
              ANA EKRAN
            </Button>
          </Link>
        </div>
        <div className="page-move-vrf">
          <Link to="/vrfhacim">
            <Button
              className={classes.navigationButtonBack + " movebuttonsvrf"}
              variant="contained"
            >
              Geri
            </Button>
          </Link>
          <Link to="/vrf1">
            <Button
              className={classes.navigationButtonForward + " movebuttonsvrf"}
              variant="contained"
            >
              İleri
            </Button>
          </Link>
        </div>

        {active_rm2 && (
          <div key={"sistem1"}>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={true}
              onClose={() => {}}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              {renderModalContent2("Sistem Kat-2")}
            </Modal>
          </div>
        )}

        <div className={classes.buttonContainer}>
          {open.map((isOpen, index) => {
            const roomNumber = 701 + index;
            const roomClass = `vrf-oda${roomNumber}`;
            const roomLabel = roomNames[roomNumber];

            // Cihaz durumunu belirleyen tagId
            const tagId = getTagIdForRoomCihaz(roomNumber);

            // Operation mode'ı belirleyen tagId
            const operationModeTagId = getTagIdForRoomOperationMode(roomNumber);

            // Set değerini belirleyen tagId
            const setDegerTagId = getTagIdForRoomSetDeger(roomNumber);

            // Yeni değeri belirleyen tagId
            const anlikTagId = getTagIdForRoomAnlik(roomNumber);

            // Arıza durumunu gösteren tagId
            const arizaTagId = getTagIdForRoomAriza(roomNumber);

            // Cihaz durumunu belirleyen render_state değerleri
            const değerler = render_state
              .filter((a) => String(a.tagId) === tagId)
              .map((b) => b.tagValue);
            const değerler_eleman = değerler[0];

            const normalizedCihazDurumu = değerler_eleman !== undefined
              ? (Number(değerler_eleman.toString().trim()) === 0 ? "0" : "1")
              : "0";
            const cihazDurumuText = normalizedCihazDurumu === "0" ? "OFF" : "ON";
            let cihazRengi =
              normalizedCihazDurumu === "0" ? "lightgray" : "rgb(237, 188, 69)";

            // Arıza durumunu belirleyen render_state değerleri
            const arizaDeğerler = render_state
              .filter((a) => String(a.tagId) === arizaTagId)
              .map((b) => b.tagValue);
            const arizaDurumu = arizaDeğerler[0];

            const normalizedArizaDurumu = arizaDurumu !== undefined
              ? (Number(arizaDurumu.toString().trim()) === 1 ? "1" : "0")
              : "0";
            // Eğer arıza durumu '1' ise cihaz rengi kırmızıya ayarlanır
            if (normalizedArizaDurumu === "1") {
              cihazRengi = "red";
            }

            // Operation mode'unu belirleyen render_state değerleri
            const operationModeDeğerler = render_state
              .filter((a) => String(a.tagId) === operationModeTagId)
              .map((b) => b.tagValue);
            const operationModeDeğer = operationModeDeğerler[0];

            const normalizedOperationMode = operationModeDeğer !== undefined
              ? String(Math.round(Number(operationModeDeğer.toString().trim())))
              : "0";

            // Set değerini belirleyen render_state değerleri
            const setDegerDeğerler = render_state
              .filter((a) => String(a.tagId) === setDegerTagId)
              .map((b) => b.tagValue);
            const setDeger = setDegerDeğerler[0];

            // Yeni değerini belirleyen render_state değerleri
            const newValueDeğerler = render_state
              .filter((a) => String(a.tagId) === anlikTagId)
              .map((b) => b.tagValue);
            const newValue = newValueDeğerler[0];

            // Operation mode'a göre renk ayarla
            let operationModeRengi = "gray"; // Varsayılan gri
            if (normalizedOperationMode === "1") {
              operationModeRengi = "cornflowerblue";
            } else if (normalizedOperationMode === "2") {
              operationModeRengi = "red";
            }

            return (
              <div key={roomNumber} className="vrf-buttonlar">
                <Button
                  className={`${classes.button} ${roomClass} vrfbuttons`}
                  onClick={() => {
                    Set_active_room_number(roomNumber);
                    handleOpen(index);
                  }}
                  style={{
                    backgroundColor: cihazRengi || cihazled[String(roomNumber)],
                  }}
                >
                  {`${roomLabel} `}

                  {/* Yeni değer için div */}
                  <span
                    style={{
                      position: "absolute",
                      right: "52%",
                      top: "40%",
                      border: "1px solid black",
                      padding: "4px",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                    }}
                  >
                    {`ODA : ${newValue} °C`}
                  </span>

                  <div
                    className="operationmodeIndicator"
                    style={{
                      display: "inline-block",
                      backgroundColor: operationModeRengi,
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      marginLeft: "15%",
                      marginTop: "15%",
                    }}
                  ></div>

                  {/* SET : "değer" kısmı */}
                  <span
                    style={{
                      position: "absolute",
                      left: "67%",
                      top: "40%",
                      border: "1px solid black",
                      borderRadius: "5px",
                      padding: "4px",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                    }}
                  >
                    {`SET : ${setDeger}`}
                  </span>
                </Button>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  className={classes.modal}
                  open={isOpen}
                  onClose={() => handleClose(index)}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    timeout: 500,
                  }}
                >
                  {renderModalContent(roomNumber)}
                </Modal>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    vrfks_tags: state.project_reducer.vrfks_tags,
    tag_list: state.project_reducer.tag_list,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    uid: state.auth_reducer.user_id,
  };
};

export default connect(MapStateToProps)(VRFKS);
